import { ApiClient } from '../../common/services/apiClient';
import type {
  AsignarResponsableBody,
  Cadena,
  FechaDia,
  Responsable,
  ResultadoAsignacion,
} from '../../negocio/negocio.types';

/**
 * Responsables por tienda (Consulta CM, fase 1). La lista la pueden leer
 * superadmin, admin e indicadores; el historial y reasignar, sólo TI.
 * ⚠️ Los nombres son LLAVES DE ACCESO de Metas: reasignar mueve quién ve,
 * captura y autoriza.
 */
export class ResponsablesService {
  static listar(fecha?: FechaDia): Promise<Responsable[]> {
    return ApiClient.get<Responsable[]>(
      fecha ? `/tiendas/responsables?fecha=${encodeURIComponent(fecha)}` : '/tiendas/responsables',
    );
  }

  static historial(cadena: Cadena | string, num: number): Promise<Responsable[]> {
    return ApiClient.get<Responsable[]>(`/tiendas/${encodeURIComponent(cadena)}/${num}/responsables`);
  }

  static asignar(cadena: Cadena | string, num: number, body: AsignarResponsableBody): Promise<ResultadoAsignacion> {
    return ApiClient.put<ResultadoAsignacion>(`/tiendas/${encodeURIComponent(cadena)}/${num}/responsable`, body);
  }
}
